import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Info } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface KPICardProps {
  title: string;
  value: string;
  icon?: React.ReactNode;
  platformLogo?: string;
  platformName?: string;
  tooltip?: string;
}

export function KPICard({ title, value, icon, platformLogo, platformName, tooltip }: KPICardProps) {
  useLanguage();
  return (
    <div className="bg-white rounded-2xl border border-[#E7EAF2] p-4 min-h-[120px] sm:min-h-[136px] flex flex-col justify-center transition-all duration-200 mb-[14px] sm:mb-0">
      {/* Conteúdo Centralizado */}
      <div className="flex flex-col justify-center">
        {/* Título da Métrica + Tooltip */}
        <div className="flex items-center gap-1.5 mb-2">
          <p className="!text-[16px] font-semibold text-[#64748B]" style={{ fontSize: '15px !important' }}>
            {title}
          </p>
          {tooltip && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Info className="h-[16px] w-[16px] text-[#94A3B8] cursor-help flex-shrink-0 ml-1.5" />
                </TooltipTrigger>
                <TooltipContent side="top" className="max-w-xs">
                  <p className="text-base">{tooltip}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>

        {/* Número Principal */}
        <p className="!text-[22px] font-semibold text-[#1C2939] !leading-none mb-2" style={{ fontSize: '20px !important' }}>
          {value}
        </p>

        {/* Subtítulo Explicativo */}
        <p className="!text-[14px] font-normal text-[#94A3B8]" style={{ fontSize: '14px !important' }}>
          {platformName ? translateInterfaceText("{value0} ficou no topo", { value0: (platformName) }) : translateInterfaceText("Ainda não há dados suficientes")}
        </p>
      </div>
    </div>
  );
}
